module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/food/cheese-56c2af3a3cce6e13904b28fa82844982.svg";